import React, { useEffect, useRef, useState } from "react";
import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";

const styles = {
  width: "100%",
  height: "400px",
};

const MapboxGLMap = (props) => {
  const [map, setMap] = useState(null);
  const mapContainer = useRef(null);

  useEffect(() => {
    mapboxgl.accessToken = 'pk.eyJ1IjoicmljYXJkb21hcml6IiwiYSI6ImNqcnRud2ZjazAza2YzeW80ZGF1MGM2MGYifQ.002bk0MBgNb5Vo-n4olFYQ';
    const initializeMap = ({ setMap, mapContainer }) => {
      const map = new mapboxgl.Map({
        container: mapContainer.current,
        style: "mapbox://styles/tiagocolucci/cjrkztd5r05o82sqtloa0zu5x", // stylesheet location
        center: [-34.871364, -8.061984],
        zoom: 14,
        interactive: true
      });

      new mapboxgl.Marker()
        .setLngLat([-34.871364, -8.061984])
        .addTo(map);

      map.on("load", () => {
        setMap(map);
        map.resize();
      });
    };

    if (!map) initializeMap({ setMap, mapContainer });
  }, [map, props.windfarms]);

  return <div ref={el => (mapContainer.current = el)} style={styles} />;
};

export default MapboxGLMap;
